export default {
  auth: null,
  id: null,
  partner: {
    address1st: null,
    address2nd: null,
    email: null,
    faxNo: null,
    id: null,
    nameJa: null,
    phoneNo: null,
    postCode: null,
    prefecture: null,
  },
  partnerType: null,
};
